"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionTable = void 0;
// ;(function (globals) {
const jquery_1 = __importDefault(require("jquery"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const RetentionCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionCalculations");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const retentionTableDefaults = {
    repeatLevels: {
        'low': [0, 10],
        'medium-low': [10, 20],
        'medium': [20, 30],
        'medium-high': [30, 40],
        'high': [40, 60],
        'hot': [60, 70],
        'extra-hot': [70, 100]
    },
    labels: {
        time: 'Time',
        people: 'Users',
        avg: 'AVG'
    },
    classPrefix: 'retention-table-',
};
const formatHeaderLabel = (periodIndex, retentionPeriods) => {
    if (retentionPeriods) {
        return (retentionPeriods[periodIndex]).toString();
    }
    else {
        return (periodIndex).toString();
    }
};
// function extend(...args) {
//     var target = arguments[0];
//     if (arguments.length === 1) {
//         return target;
//     }
//
//     for (var i = 1; i < arguments.length; i++) {
//         var source = arguments[i];
//         for (var prop in source) {
//             target[prop] = source[prop];
//         }
//     }
//
//     return target;
// }
function isNumber(val) {
    return Object.prototype.toString.call(val) === '[object Number]';
}
function isEmpty(val) {
    return val === null || val === undefined || val === "";
}
function formatTimeLabel(initialDateMoment, dayPeriod) {
    return initialDateMoment.clone().add(dayPeriod, "day").format("MM/DD/YYYY");
}
const draw = function (options) {
    if (!!process.env.IS_TEST_SERVER) {
        console.log("draw", { ...options });
    }
    const isStickinessType = options.type === "stickiness";
    // const createDOMStart = performance.now()
    if (!options.cohort) {
        throw new Error("Please provide the cohort data");
    }
    if (!options.container) {
        throw new Error("Please provide the cohort container");
    }
    const initialDateMillis = options.initialDateMillis;
    const initialDateMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(options.initialDateMillis);
    const currentDayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay();
    const classNameBuilder = function (value) {
        const levels = options.repeatLevels;
        const floatValue = value && parseFloat(value);
        let highestLevel;
        const classNames = ['percentage'];
        for (let level in levels) {
            if (floatValue >= levels[level][0] && floatValue < levels[level][1]) {
                classNames.push(level);
                return classNames.join(" ");
            }
            highestLevel = level;
        }
        // handle 100% case
        classNames.push(highestLevel);
        return classNames.join(" ");
    };
    function create(el, options) {
        options = options || {};
        el = document.createElement(el);
        const className = options.className;
        if (className) {
            delete options.className;
            el.className = prefixClass(className);
        }
        if (!isEmpty(options.text)) {
            const text = options.text.toString();
            // noinspection JSDeprecatedSymbols
            if (document.all) {
                el.innerText = text;
            }
            else {
                el.textContent = text;
            }
            delete options.text;
        }
        else if (!isEmpty(options.html)) {
            el.innerHTML = options.html.toString();
            delete options.html;
        }
        for (let option in options) {
            const opt = options[option];
            if (opt) {
                el[option] = opt;
            }
        }
        return el;
    }
    // prefix any css class we use in order to avoid any possible clashes
    function prefixClass(className) {
        const prefixedClass = [];
        const classes = className.split(/\s+/);
        for (let i in classes) {
            prefixedClass.push(options.classPrefix + classes[i]);
        }
        return prefixedClass.join(" ");
    }
    function drawLeftHeader(cohortName) {
        const divRow = create('div', { className: 'row' });
        divRow.appendChild(create('div', { text: cohortName, className: 'cell header' }));
        divRow.appendChild(create('div', { text: options.labels.people, className: 'cell header' }));
        return divRow;
    }
    function drawRightHeader(cohortPeriods, cellWidthPercent, options) {
        // console.log("drawRightHeader", {cohortPeriods, cellWidthPercent, ...options});
        const divRow = create('div', { className: 'row' });
        if (cohortPeriods > 0) {
            for (let periodIndex = 0; periodIndex < cohortPeriods; periodIndex++) {
                let label = formatHeaderLabel(periodIndex, options.retentionPeriods);
                if (options.type === "stickiness") {
                    if (options.stickinessType === 'cumulative') { /*retentionType === 'frequency' ||*/
                        label = '≥ ' + label + '/7';
                    }
                    else if (options.stickinessType === 'nonCumulative') { /*retentionType === 'frequency_nc' ||*/
                        label = label + '/7';
                    }
                }
                const divCell = create('div', {
                    text: label,
                    className: 'cell header',
                    id: 'column_' + formatHeaderLabel(periodIndex, options.retentionPeriods),
                    style: 'width: ' + cellWidthPercent + '%;'
                });
                divRow.appendChild(divCell);
                if (options.retentionPeriods) {
                    (0, jquery_1.default)(divCell).data("period", options.retentionPeriods[periodIndex]);
                }
                else {
                    (0, jquery_1.default)(divCell).data("period", periodIndex);
                }
                (0, jquery_1.default)(divCell).data("periodName", periodIndex);
            }
        }
        else {
            divRow.appendChild(create('div', { className: 'cell', html: "&nbsp;" }));
        }
        return divRow;
    }
    //AVG header row - Users
    function drawLeftHeaderAvg(data, cohortPeriods) {
        // console.log("drawLeftHeaderAvg", {data, cohortPeriods});
        const divRow = create('div', { className: 'row' });
        const thChild = create('div', { text: options.labels.avg, className: 'cell header' }); /*selectable*/
        divRow.appendChild(thChild);
        (0, jquery_1.default)(thChild).data("period", 'avg');
        (0, jquery_1.default)(thChild).data("periodName", 'avg');
        if (cohortPeriods > 0) {
            for (let i = 0; i < cohortPeriods; i++) {
                let totalCohort = 0;
                let cohortsCalculated = 0;
                if (i === 0) {
                    let incompleteDataCalculated = false;
                    for (let rowIndexCohort = 0; rowIndexCohort < data.length; rowIndexCohort++) {
                        const allDataLoaded = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, rowIndexCohort, options.cohortCheckEndDays);
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("drawLeftHeaderAvg:", { rowIndexCohort, allDataLoaded, incompleteDataCalculated });
                        }
                        if (incompleteDataCalculated || allDataLoaded) {
                            totalCohort += (data[rowIndexCohort][0] || 0);
                            cohortsCalculated++;
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("new totalCohort 1:", totalCohort, "new cohortsCalculated", cohortsCalculated);
                            }
                        }
                        else if (!allDataLoaded && totalCohort === 0) {
                            totalCohort += (data[rowIndexCohort][0] || 0);
                            cohortsCalculated++;
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("new totalCohort 2:", totalCohort, "new cohortsCalculated", cohortsCalculated);
                            }
                            incompleteDataCalculated = true;
                        }
                    }
                    let usersAvg;
                    if (totalCohort === 0 || cohortsCalculated === 0) {
                        usersAvg = (0).toFixed(0);
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("usersAvg:", `${totalCohort} / ${cohortsCalculated}`, usersAvg);
                        }
                    }
                    else {
                        usersAvg = (totalCohort / cohortsCalculated).toFixed(0);
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("usersAvg:", `${totalCohort} / ${cohortsCalculated}`, (totalCohort / cohortsCalculated), usersAvg);
                        }
                    }
                    let cellValue;
                    if (incompleteDataCalculated) {
                        cellValue = '*' + usersAvg;
                    }
                    else {
                        cellValue = usersAvg;
                    }
                    divRow.appendChild(create('div', { text: cellValue, className: 'cell header' }));
                }
            }
        }
        else {
            divRow.appendChild(create('div', { className: 'cell header', html: "&nbsp;" }));
        }
        return divRow;
    }
    //AVG header row - cells
    function drawRightHeaderAvg(data, cohortPeriods, cellWidthPercent, options) {
        /**
         * Stickiness:
         * options.retentionPeriods = [1, 2, 3, 4, 5, 6, 7
         */
        const divRow = create('div', { className: 'row' });
        if (!!process.env.IS_TEST_SERVER) {
            console.log("drawRightHeaderAvg: cohortPeriods", cohortPeriods);
            console.log("drawRightHeaderAvg: retentionPeriods", options.retentionPeriods);
            console.log("drawRightHeaderAvg: cohortCheckEndDays", options.cohortCheckEndDays);
        }
        if (cohortPeriods > 0) {
            for (let periodIndex = 0; periodIndex < cohortPeriods; periodIndex++) {
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("drawRightHeaderAvg: ==================================================== periodIndex", periodIndex);
                }
                let counter = 0;
                let totalCohort = 0;
                let totalRetention = 0;
                let incompleteDataCalculated = false;
                for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
                    const row = data[rowIndex];
                    if (periodIndex < row.length - 1) {
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("drawRightHeaderAvg: rowIndex", rowIndex, row);
                        }
                        if (row[0] > 0) {
                            const fullCohortLoaded = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, rowIndex, options.cohortCheckEndDays);
                            //for stickiness, we check only if day is complete
                            const fullPeriodLoaded = isStickinessType ? true : RetentionCalculations_1.RetentionCalculations.isFullPeriodLoaded(initialDateMillis, rowIndex, CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeTypeToRetentionType(options.type === "retention" ? options.retentionType : "nDay"), options.retentionPeriods[periodIndex]);
                            const allDataLoaded = fullCohortLoaded && fullPeriodLoaded;
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("drawRightHeaderAvg: ", { allDataLoaded, fullCohortLoaded, fullPeriodLoaded });
                            }
                            if (incompleteDataCalculated || allDataLoaded) {
                                totalCohort = totalCohort + row[0];
                                totalRetention = totalRetention + row[periodIndex + 1];
                                counter++;
                                // console.log("rowIndex 1:", rowIndex);
                            }
                            else if (!allDataLoaded && totalCohort === 0) {
                                totalCohort = totalCohort + row[0];
                                totalRetention = totalRetention + row[periodIndex + 1];
                                counter++;
                                incompleteDataCalculated = true;
                                // console.log("rowIndex 2:", rowIndex);
                            }
                        }
                    }
                }
                let cellValue;
                let hoverValue;
                if (totalRetention === 0 || totalCohort === 0) {
                    cellValue = (0).toFixed(2);
                    hoverValue = cellValue + '% (' + (0).toFixed(0) + ' of ' + (0).toFixed(0) + ')';
                }
                else {
                    cellValue = (totalRetention / totalCohort * 100).toFixed(2);
                    hoverValue = cellValue + '% (' + (totalRetention / counter).toFixed(2) + ' of ' + (totalCohort / counter).toFixed(2) + ')';
                }
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("drawRightHeaderAvg: total", { periodIndex, totalRetention, totalCohort, counter, cellValue, hoverValue });
                }
                let cellValuePrefix;
                if (incompleteDataCalculated) {
                    cellValuePrefix = '*';
                }
                else {
                    cellValuePrefix = '';
                }
                divRow.appendChild(create('div', {
                    text: cellValuePrefix + cellValue,
                    title: hoverValue,
                    className: 'cell ' + classNameBuilder(cellValue),
                    style: 'width: ' + cellWidthPercent + "%;"
                }));
            }
        }
        else {
            divRow.appendChild(create('div', { className: 'cell', html: "&nbsp;" }));
        }
        return divRow;
    }
    //Date rows - Users
    function drawLeftCells(data) {
        const divRowSpace = create('div', { className: 'row' });
        divRowSpace.appendChild(create('div', { className: 'cell header' }));
        divRowSpace.appendChild(create('div', { className: 'cell header' }));
        const resultTable = document.createDocumentFragment();
        resultTable.appendChild(divRowSpace);
        for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
            const divRow = create('div', { className: 'row' });
            const row = data[rowIndex];
            const tdChild = create('div', {
                className: 'cell header',
                text: formatTimeLabel(initialDateMoment, rowIndex),
            });
            //date
            divRow.appendChild(tdChild);
            (0, jquery_1.default)(tdChild).data("periodIndex", rowIndex);
            (0, jquery_1.default)(tdChild).data("periodName", formatTimeLabel(initialDateMoment, rowIndex));
            let value;
            let isCompleteRow = false;
            if (isStickinessType) {
                const rowMoment = initialDateMoment.clone().add(rowIndex, "days");
                // noinspection UnnecessaryLocalVariableJS
                const isCurrentDayAfter = currentDayMoment.isAfter(rowMoment, "day");
                isCompleteRow = isCurrentDayAfter;
            }
            else {
                isCompleteRow = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, rowIndex, options.cohortCheckEndDays);
            }
            if (isCompleteRow) {
                value = row[0] || 0;
            }
            else {
                value = '*' + (row[0] || 0);
            }
            //users count
            divRow.appendChild(create('div', { text: value, className: 'cell header' }));
            resultTable.appendChild(divRow);
        }
        return resultTable;
    }
    //Date rows - cells
    function drawCells(data, cohortPeriods, cellWidthPercent, options) {
        const formatPercentage = function (value, base) {
            if (isNumber(value) && base > 0) {
                return (value / base * 100).toFixed(2);
            }
            else if (isNumber(value)) {
                return "0.00";
            }
        };
        const divRowSpace = create('div', { className: 'row' });
        if (cohortPeriods > 0) {
            for (let p = 0; p < cohortPeriods; p++) {
                divRowSpace.appendChild(create('div', { className: 'cell', style: 'width: ' + cellWidthPercent + "%;" }));
            }
        }
        else {
            divRowSpace.appendChild(create('div', { className: 'cell' }));
        }
        const resultTable = document.createDocumentFragment();
        resultTable.appendChild(divRowSpace);
        for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
            const divRow = create('div', { className: 'row' });
            const row = data[rowIndex];
            const baseValue = row[0];
            // console.log(`row[${rowIndex}]`, baseValue, row);
            if (baseValue === 0 || baseValue === undefined) {
                // for (var index = 0; index < cohortPeriods; index++) {
                //     divRow.appendChild(create('div', {className: 'cell', style: 'width: ' + cellWidthPercent + "%;", html: "&nbsp;"}));
                // }
                divRow.appendChild(create('div', { className: 'cell', style: 'width: ' + cellWidthPercent + "%;", html: "&nbsp;" }));
            }
            else {
                let isCompleteCell = false;
                if (isStickinessType) {
                    const rowMoment = initialDateMoment.clone().add(rowIndex, "days");
                    // noinspection UnnecessaryLocalVariableJS
                    const isCurrentDayAfter = currentDayMoment.isAfter(rowMoment, "day");
                    isCompleteCell = isCurrentDayAfter;
                }
                for (let colIndex = 1; colIndex < row.length; colIndex++) {
                    const value = row[colIndex];
                    let cellValue;
                    let hoverValue;
                    let cellValuePrefix;
                    if (!isStickinessType) {
                        isCompleteCell = RetentionCalculations_1.RetentionCalculations.isCohortComplete(initialDateMillis, rowIndex, options.cohortCheckEndDays)
                            && RetentionCalculations_1.RetentionCalculations.isFullPeriodLoaded(initialDateMillis, rowIndex, CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeTypeToRetentionType(options.type === "retention" ? options.retentionType : "nDay"), options.retentionPeriods[colIndex - 1]);
                    }
                    if (isCompleteCell) {
                        cellValuePrefix = '';
                    }
                    else {
                        cellValuePrefix = '*';
                    }
                    cellValue = formatPercentage(value, baseValue);
                    hoverValue = cellValue + '% (' + value + ' of ' + baseValue + ')';
                    let opts = {};
                    if (!isEmpty(cellValue)) {
                        opts = {
                            text: cellValuePrefix + cellValue,
                            title: hoverValue,
                            className: 'cell ' + classNameBuilder(cellValue),
                            style: 'width: ' + cellWidthPercent + "%;"
                        };
                    }
                    else {
                        opts = { text: '-', className: 'empty' };
                    }
                    divRow.appendChild(create('div', opts));
                }
            }
            resultTable.appendChild(divRow);
        }
        return resultTable;
    }
    let cohortPeriods;
    for (let index = 0; index < options.cohort.length; index++) {
        if (options.cohort[index] && options.cohort[index].length > 1) {
            cohortPeriods = options.cohort[index].length - 1;
            break;
        }
    }
    const cellWidthPercent = (100 / cohortPeriods).toFixed(2);
    // left top/bottom tables
    const leftTopTable = create('div', { className: 'top-table', style: 'display: table; width:100%; ' });
    leftTopTable.appendChild(drawLeftHeader(options.cohortName));
    leftTopTable.appendChild(drawLeftHeaderAvg(options.cohort, cohortPeriods));
    const leftBottomTable = create('div', { className: 'bottom-table', style: 'width:100%;' });
    leftBottomTable.appendChild(drawLeftCells(options.cohort));
    // right top/bottom tables
    const rightTopTable = create('div', { className: 'top-table', style: 'display: table; width:100%;' });
    rightTopTable.appendChild(drawRightHeader(cohortPeriods, cellWidthPercent, options));
    rightTopTable.appendChild(drawRightHeaderAvg(options.cohort, cohortPeriods, cellWidthPercent, options));
    const rightBottomTable = create('div', { className: 'bottom-table', style: 'width:100%;' });
    rightBottomTable.appendChild(drawCells(options.cohort, cohortPeriods, cellWidthPercent, options));
    // left container with tables
    const leftContainer = create('div', { className: 'left-container', style: 'float:left;' });
    leftContainer.appendChild(leftTopTable);
    leftContainer.appendChild(leftBottomTable);
    // right container with tables
    const rightContainer = create('div', { className: 'right-container', style: 'overflow-x:auto;' });
    rightContainer.appendChild(rightTopTable);
    rightContainer.appendChild(rightBottomTable);
    options.container.style.display = "none";
    options.container.innerHTML = leftContainer.outerHTML + rightContainer.outerHTML;
    options.container.style.display = "block";
};
class RetentionTable {
    constructor(opts) {
        this.config = {
            ...retentionTableDefaults,
            ...opts
        };
    }
}
exports.RetentionTable = RetentionTable;
RetentionTable.draw = (options) => {
    // console.log("RetentionTable draw: options", options)
    const retentionTable = new RetentionTable(options);
    draw(retentionTable.config);
    return options.container;
};
